import { render, staticRenderFns } from "./add_item.vue?vue&type=template&id=4c105e4c&scoped=true&"
import script from "./add_item.vue?vue&type=script&lang=js&"
export * from "./add_item.vue?vue&type=script&lang=js&"
import style0 from "./add_item.vue?vue&type=style&index=0&id=4c105e4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c105e4c",
  null
  
)

export default component.exports